module.exports = __webpack_public_path__ + "img/nt85-09-82-1.prt.b350585f.jpg";